<template>
	<div>

		<v-btn color="blue-grey" class="mb-4 white--text" @click="volverAlMenu" :disabled="volviendo" :loading="volviendo">Volver al menú</v-btn>

		<opcion-personalizar :opción="pedido ? pedido.opción : null" @concluir="trasPersonalizar"></opcion-personalizar>

		<v-dialog
			v-model="verResumen"
			width="500"
			persistent
		>
			<v-card
				class="mx-auto"
				max-width="500"
				v-if="pedido && pedido.opción"
			>

				<v-card-title>Resumen del pedido</v-card-title>
				<v-card-text>
					<p>Revise a continuación el resumen del pedido. Si todo está bien, puede proceder a agregarlo a la lista.</p>
				</v-card-text>

				<v-divider></v-divider>

				<opcion-resumen :opción="pedido ? pedido.opción : null"></opcion-resumen>

				<v-divider></v-divider>

				<v-card-text>

					<br>

					<p class="pt-4">Seleccione la mesa a la cual va el pedido:</p>
					<v-select
						v-model="$data._ubicación"
						:items="ubicaciones"
						item-text="nombre"
						item-value="id"
						label="Ubicación"
						outlined
					></v-select>


					<p class="pt-4">¿Desea agregar notas adicionales para tener en cuenta en el pedido?</p>
					<v-textarea
						v-model="pedido.notas"
						label="Comentarios adicionales"
						outlined
					></v-textarea>

				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
					<v-btn
						depresed
						@click="verResumen = false"
					>
						Regresar
					</v-btn>
					&nbsp;&nbsp;&nbsp;
					<v-btn
					v-if="pedido.estado === 'NUEVO'"
						color="info"
						depresed
						:disabled="!pedido.ubicación"
						@click="agregarPedido"
					>
						Agregar a la lista
					</v-btn>
					<v-btn
					v-if="pedido.estado === 'NO_ORDENADO'"
						color="info"
						depresed
						:disabled="!pedido.ubicación"
						@click="modificarPedidoNoOrdenado"
					>
						Guardar cambios
					</v-btn>
					<v-btn
					v-if="pedido.estado === 'ORDENADO'"
						color="info"
						depresed
						:disabled="!pedido.ubicación || modificando"
						:loading="modificando"
						@click="modificarPedidoOrdenado"
					>
						Guardar cambios
					</v-btn>
				</v-card-actions>

			</v-card>
		</v-dialog>

	</div>
</template>

<script>
import OpcionResumen from '../opciones/Opcion_Resumen';
import OpcionPersonalizar from '../opciones/Opcion_Personalizar';

export default {
	name: 'PedidoOpcionPersonalizar',
	data: () => ({
		verResumen: false,
		_ubicación: '',
		volviendo: false,
		modificando: false
	}),
	props: ['pedido', 'ubicaciones'],
	components: {
		OpcionResumen,
		OpcionPersonalizar,
	},
	watch: {
		'pedido': {
			handler: function(v) {
				if (v && v.estado === 'NUEVO' && this.$data._ubicación) {
					this.pedido.ubicación = this.ubicaciones.find( u => u.id === this.$data._ubicación)
					return
				}

				if (!this.$data._ubicación && v && v.ubicación && v.ubicación.id) {
					this.$data._ubicación = v.ubicación.id
				} else if (!this.$data._ubicación && v && v.ubicación && v.ubicación.identificación && v.ubicación.tipo) {
					let u = this.ubicaciones.find( u => u.identificación === v.ubicación.identificación && u.tipo === v.ubicación.tipo)
					this.$data._ubicación = u.id
				}
			},
			deep: true
		},
		'$data._ubicación': function(id) {
			if (!id) {
				return
			}

			this.pedido.ubicación = this.ubicaciones.find( u => u.id === id)
		}
	},
	methods: {
		trasPersonalizar: function(v) {
			this.verResumen = true
		},
		volverAlMenu: function() {
			if (this.pedido.modificando) {
				this.volviendo = true
				this.$root.axios.patch(`/pedidos/${this.pedido.id}`, {modificando: false}).then(rta => {
					this.volviendo = false
					this.$emit('modificado')
				}).catch(err => {
					this.volviendo = false
					alert('Ocurrió un error. Recargue la página e intente de nuevo. [4393]') // Esto no debería ocurrir
				})
			} else {
				this.$emit('volver')
			}
		},
		agregarPedido: function() {
			this.verResumen = false
			this.$data._ubicación = ''
			this.pedido.estado = 'NO_ORDENADO'
			this.$emit('agregar', true)
		},
		modificarPedidoNoOrdenado: function() {
			this.verResumen = false
			this.$data._ubicación = ''
			this.$emit('modificado', true)
		},
		modificarPedidoOrdenado: function() {
			this.modificando = true
			this.$root.axios.put(`/pedidos/${this.pedido.id}`, this.pedido).then(rta => {
				this.verResumen = false
				this.$data._ubicación = ''
				this.modificando = false
				this.$emit('modificado', true)
			}).catch(err => {
				this.modificando = false
				alert(err.error || 'Ocurrió un error al modificar el pedido. Intente de nuevo.')
			})
		}
	}
}
</script>